import { render, staticRenderFns } from "./checkout-headline.vue?vue&type=template&id=d8fa4756&scoped=true"
import script from "./checkout-headline.vue?vue&type=script&lang=js"
export * from "./checkout-headline.vue?vue&type=script&lang=js"
import style0 from "./checkout-headline.vue?vue&type=style&index=0&id=d8fa4756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fa4756",
  null
  
)

export default component.exports